import styled from 'styled-components';

import { baseColors } from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const Wrapper = styled.div`
    position: relative;

    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 100vh;
`;

export const BackgroundImage = styled.img`
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    object-fit: cover;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 450px;
    max-width: 90%;

    color: white;
    text-align: center;
`;

export const Title = styled.h1`
    margin: 0;
    margin-bottom: ${themeSpacing.sm3};

    font-size: ${text.size.header.extraLarge};
    font-feature-settings: 'liga' off, 'clig' off;
    font-weight: 600;
    font-style: normal;
    line-height: 120%;
    letter-spacing: -0.05rem;
`;

export const Description = styled.p`
    margin: 0;
    margin: 0 ${themeSpacing.md1};

    font-size: 1rem;
    font-feature-settings: 'liga' off, 'clig' off;
    font-weight: 400;
    font-style: normal;
    line-height: 120%;
    text-align: center;
    white-space: pre-wrap;
`;

export const RetryButton = styled.button`
    cursor: pointer;

    margin-top: ${themeSpacing.md2};
    padding: 12px 40px;

    font-size: 1rem;
    font-weight: 500;
    color: ${baseColors.black};

    background: white;
    border: none;
    border-radius: 9999px;

    transition: background 0.2s ease;

    &:hover {
        background: #f0f0f0;
    }
`;
